/** EU member state official UI languages (ISO 639-1). */
export const UI_LANGUAGES = [
  { code: 'bg', label: 'Български', nativeLabel: 'Български' },
  { code: 'hr', label: 'Hrvatski', nativeLabel: 'Hrvatski' },
  { code: 'cs', label: 'Čeština', nativeLabel: 'Čeština' },
  { code: 'da', label: 'Dansk', nativeLabel: 'Dansk' },
  { code: 'nl', label: 'Nederlands', nativeLabel: 'Nederlands' },
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'et', label: 'Eesti', nativeLabel: 'Eesti' },
  { code: 'fi', label: 'Suomi', nativeLabel: 'Suomi' },
  { code: 'fr', label: 'Français', nativeLabel: 'Français' },
  { code: 'de', label: 'Deutsch', nativeLabel: 'Deutsch' },
  { code: 'el', label: 'Ελληνικά', nativeLabel: 'Ελληνικά' },
  { code: 'hu', label: 'Magyar', nativeLabel: 'Magyar' },
  { code: 'ga', label: 'Gaeilge', nativeLabel: 'Gaeilge' },
  { code: 'it', label: 'Italiano', nativeLabel: 'Italiano' },
  { code: 'lv', label: 'Latviešu', nativeLabel: 'Latviešu' },
  { code: 'lt', label: 'Lietuvių', nativeLabel: 'Lietuvių' },
  { code: 'mt', label: 'Malti', nativeLabel: 'Malti' },
  { code: 'pl', label: 'Polski', nativeLabel: 'Polski' },
  { code: 'pt', label: 'Português', nativeLabel: 'Português' },
  { code: 'ro', label: 'Română', nativeLabel: 'Română' },
  { code: 'sk', label: 'Slovenčina', nativeLabel: 'Slovenčina' },
  { code: 'sl', label: 'Slovenščina', nativeLabel: 'Slovenščina' },
  { code: 'es', label: 'Español', nativeLabel: 'Español' },
  { code: 'sv', label: 'Svenska', nativeLabel: 'Svenska' },
];

export const UI_LANGUAGE_CODES = new Set(UI_LANGUAGES.map((l) => l.code));
export const DEFAULT_UI_LOCALE = 'fi';

export function isUiLocale(code) {
  return typeof code === 'string' && UI_LANGUAGE_CODES.has(code);
}

export function uiLanguageLabel(code) {
  return UI_LANGUAGES.find((l) => l.code === code)?.nativeLabel || code;
}
